import { render } from "./SmallPagePreview.vue?vue&type=template&id=399a6f18&scoped=true"
import script from "./SmallPagePreview.vue?vue&type=script&lang=js"
export * from "./SmallPagePreview.vue?vue&type=script&lang=js"

import "./SmallPagePreview.vue?vue&type=style&index=0&id=399a6f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399a6f18"]])

export default __exports__